export default __webpack_public_path__ + "static/media/hub_website.ef2e2d08.svg";